import { createSelector } from 'reselect';

const selectUberData = (state) => state.getIn(['uber']);
const selectEnterpriseData = (state) => state.getIn(['enterprise']);
const selectAudatargetData = (state) => state.getIn(['audatarget']);

export const uberSelector = createSelector(selectUberData, (x) => x.toJS());
export const enterpriseSelector = createSelector(selectEnterpriseData, (x) => x.toJS());
export const audatargetSelector = createSelector(selectAudatargetData, (x) => x.toJS());
